import { apiClient } from "lib/apiClient";
import {
  IResearchReasonRequest,
  IResearchWorkItem,
} from "features/Research/types";

export const archiveResearchWorkItem = async (
  workItemId: string,
  request: IResearchReasonRequest
): Promise<IResearchWorkItem> => {
  const response = await apiClient.put(
    `/research/work-items/${workItemId}/archival`,
    request
  );
  return response.data;
};
